export default __webpack_public_path__ + "static/media/eye_icon.1cc0ba5f.svg";